import React from 'react'
import EntryTime from '../../PositionColumns/EntryTime'
import ScreenShot from '../../PositionColumns/ScreenShot'

export const column_sc = (
	mutate,
	showmodal,
	token,
	fold,
	edit,
	setEdit,
	mshare,
	uid,
	setSC
) => {
	return [
		{
			title: '시간',
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			render: (text, record) => {
				return <EntryTime time={record?.created_at} />
			},
		},
		{
			title: '보기',
			dataIndex: 'data',
			key: 'data',
			align: 'center',
			render: (text, record) => {
				return <ScreenShot data={record} setEdit={setSC} />
			},
		},
	]
}
